import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZapResponse } from '../models/responses/zap-response';
import { Observable } from 'rxjs';
import { environment } from '../environments/environments';


@Injectable({
  providedIn: 'root'
})
export class ZapService {

  constructor(private httpClient: HttpClient) { }

  createZap(zap: ZapResponse): Observable<ZapResponse> {
    return this.httpClient.post<ZapResponse>(`${environment.zapUrl}/createZap`, zap);
  }

  updateZap(zap: ZapResponse): Observable<ZapResponse> {
    return this.httpClient.put<ZapResponse>(`${environment.zapUrl}/updateZap`, { zap });
  }

  fetchAllZap(integrationId: number): Observable<ZapResponse[]> {
    return this.httpClient.get<ZapResponse[]>(`${environment.zapUrl}/fetchAllAiAgentZaps/${integrationId}`);
  }

  delete(zapId: number): Observable<ZapResponse[]> {
    return this.httpClient.delete<ZapResponse[]>(`${environment.zapUrl}/delete/${zapId}`);
  }

  testZap(zapId: string, body: any){
    return this.httpClient.post(`${environment.zapUrl}/testZap`, {zapId, body});
  }
}